// extracted by mini-css-extract-plugin
module.exports = {"container":"CdsamFormFooter_container__1bbRD","button":"CdsamFormFooter_button__25QM4","button-ltr":"CdsamFormFooter_button-ltr__2XgDI"};